import { render } from "./PatientComponent.vue?vue&type=template&id=1a49168c&scoped=true"
import script from "./PatientComponent.vue?vue&type=script&lang=js"
export * from "./PatientComponent.vue?vue&type=script&lang=js"

import "./PatientComponent.vue?vue&type=style&index=0&id=1a49168c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a49168c"]])

export default __exports__